import { FC } from 'react';
import {
  Typography,
  Button,
  Avatar,
  Icon,
  tailwindOverride,
  decimalHoursToTimeString,
} from '@getsynapse/design-system';
import { Submitter } from 'types/store/actualHours';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { getInitials } from 'utils/functions';

interface AccordionTriggerProps {
  submitter: Submitter;
  totalHours: number;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
}

const AccordionTrigger: FC<AccordionTriggerProps> = ({
  submitter,
  totalHours,
  isExpanded,
  toggleIsExpanded,
}) => {
  const [firstName, lastName] = submitter.name.split(' ');
  const initials = getInitials({
    firstName,
    lastName,
  });

  const { flexibleTaskTimeEntry } = useFlags();

  const totalHoursField = flexibleTaskTimeEntry
    ? decimalHoursToTimeString(totalHours)
    : `${totalHours}h`;

  return (
    <Typography variant='h3'>
      <Button
        variant='tertiary'
        id={`submitter-${submitter.id}__accordion-trigger`}
        aria-label={`submitter-${submitter.id}__accordion-trigger`}
        aria-expanded={isExpanded}
        aria-controls={`submitter-${submitter.id}__accordion-content`}
        onClick={toggleIsExpanded}
        className={tailwindOverride(
          'flex items-center justify-between',
          'w-full pr-0 pl-2 py-2'
        )}
      >
        <div className='flex gap-x-2 items-center'>
          <div
            style={{
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
            }}
          >
            <Icon name='chevron-forward' className='color-neutral text-base' />
          </div>
          <Avatar size='small' name={submitter.name} initial={initials} />
          <Typography variant='body'>{submitter.name}</Typography>
        </div>
        <Typography variant='body' className='mr-14' weight='medium'>
          {totalHoursField}
        </Typography>
      </Button>
    </Typography>
  );
};

export default AccordionTrigger;
